import React from 'react';

const Producto = ({datos}) => {
	return (
		<article className='producto'>
			<img src={`./img/productos/${datos.producto}`} alt='imagen producto' className='producto__img' />
			<div className='producto__datos'>
				<h3 className='producto__title'>{datos.title}</h3>
				<div>
					<p className='producto__area'>
						Área de corte: <span>{datos.area}</span>
					</p>
					<p className='producto__precio'>
						Precio: <span>{datos.precio}</span>
					</p>
				</div>
				<a href='https://wa.me/573209377591' className='producto__btn' target='_blank' rel='noreferrer'>
					MÁS INFORMACIÓN
				</a>
			</div>
		</article>
	);
};

Producto.defaultProps = {
	datos: {
		producto: '1.jpg',
		title: 'Nombre de la máquina',
		area: 'area de corte',
		precio: '$0',
	},
};

export default Producto;
